<template>
  <div
    id="box-in-the-box"
    :style="{
      top: itemData.style.top + '%',
      bottom: itemData.style.bot + '%',
      left: itemData.style.left + '%',
      right: itemData.style.right + '%',
      background: itemData.style.bcg,
      width: itemData.style.width + '%',
      height: itemData.style.height + '%',
      opacity: itemData.style.opacity,
      color: itemData.style.color || 'black',
      transform: itemData.style.transform,
      overflowY: itemData.style.scroll,
      direction: itemData.style.direction,
      boxShadow: itemData.style.shadow,
    }"
  >
    <div
      class="innerBox"
      :class="{
        'active-class': audioVisible && itemData.autoTrigger && !animationNo,
      }"
      :style="[
        audioVisible && !animationNo
          ? { transitionDelay: itemData.autoTriggerTime - 1 + 's' }
          : { transitionDelay: 0 + 's' },
        audioVisible && !animationNo && itemData.autoTrigger && itemData.autoTriggerScale
          ? { transform: 'scale(' + itemData.autoTriggerScale + ', ' + itemData.autoTriggerScale + ') !important' }
          : {},
      ]"
    >
      <div
        class="lamp"
        :class="itemData.style.hover + ' lamp'"
        v-if="itemData.type == 'lamp'"
        :style="{
          animationDuration: itemData.lampStyle.duration + 's',
          width: itemData.lampStyle.width,
          height: itemData.lampStyle.height,
          background: itemData.lampStyle.background,
          top: itemData.lampStyle.top,
          left: itemData.lampStyle.left,
          bottom: itemData.lampStyle.bot,
          right: itemData.lampStyle.right,
        }"
      ></div>
      <div
        v-if="itemData.type == 'video'"
        :style="[
          {
            width: '100%',
            height: '100%',
            cursor: itemData.style.cursor,
            animationDelay: (itemData.style.delay | 0) / 100 + 's',
            transitionDuration: '0.5s',
          },
        ]"
      >
        <div class="video">
          <video
            width="100%"
            height="100%"
            class="mb-presentation-player-video"
            :autoplay="false"
            controls
            crossorigin
            style="z-index: 1"
          >
            <source :src="itemData.video" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div class="video-title" style="font-size: 3vmin">
            <span v-html="itemData.videoTitle"></span>
          </div>
        </div>
      </div>
      <div
        v-if="itemData.type == 'img'"
        :style="[
          {
            width: '100%',
            height: '100%',
            cursor: itemData.style.cursor,
            objectPosition: itemData.style.objectPosition | 'left bottom',
            animationDelay: (itemData.style.delay | 0) / 100 + 's',
            transitionDuration: '0.5s',
          },
        ]"
        @mouseenter="hoverOnImg = true"
        @mouseleave="hoverOnImg = false"
      >
        <img
          :class="itemData.style.class"
          @click="
            showMustGoOn(itemData.showIt || itemData.content, itemData.zoom, itemData.comicShow);
            goTo(itemData.goTo);
            playSound();
          "
          @load="changeCanShowIt"
          :style="{
            width: '100%',
            height: '100%',
            cursor: itemData.style.cursor,
            objectPosition: itemData.style.objectPosition | 'left bottom',
            animationDelay: (itemData.style.delay | 0) / 100 + 's',
            border: itemData.style.border,
            borderRadius: itemData.style.borderRadius,
          }"
          :src="giveMePathPlease(itemData.content)"
        />
        <transition name="info-fade">
          <svg
            @click="
              showMustGoOn(itemData.showIt || itemData.content, itemData.zoom, itemData.comicShow);
              goTo(itemData.goTo);
              playSound();
            "
            :style="{
              height: '100px',
              width: '100px',
              cursor: itemData.style.cursor,
              objectPosition: itemData.style.objectPosition | 'left bottom',
            }"
            v-if="itemData.zoom && hoverOnImg && canShowIt"
            viewBox="0 0 24 24"
            style="position: absolute; top: calc(50% - 50px); left: calc(50% - 50px); transition: 0.3s"
          >
            <path
              fill="rgba(255,255,255, 0.6)"
              stroke="rgba(0,0,0,0.8)"
              stroke-width=".7"
              d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
            />
          </svg>
        </transition>
      </div>
      <transition name="info-fade">
        <img
          :class="itemData.style.class + ' ' + itemData.style.hover"
          :style="{
            width: '100%',
            height: '100%',
            cursor: itemData.style.cursor,
            objectPosition: itemData.style.objectPosition | 'left bottom',
            animationDelay: (0 | 0) / 100 + 's',
          }"
          v-if="itemData.type == 'comicTrigger' && !showComic && autoPlay && chceckMineBinding(itemData.bind)"
          :src="giveMePathPlease(itemData.content)"
          @click="showMustGoOn(itemData.showIt || itemData.content, itemData.zoom, itemData.comicShow, itemData.bind)"
        />
      </transition>
      <transition name="info-fade">
        <img
          :class="itemData.style.hover + ' comicText'"
          :style="{
            width: '100%',
            height: '100%',
            cursor: itemData.style.cursor,
            objectPosition: itemData.style.objectPosition | 'left bottom',
          }"
          v-if="
            itemData.type == 'comic' && showComic && checkBinding(itemData.bind) && chceckMineBinding(itemData.bind)
          "
          :src="giveMePathPlease(itemData.content)"
          @click="showMustGoOn(itemData.showIt || itemData.content, itemData.zoom)"
        />
      </transition>
      <p
        :class="itemData.style.class + ' ' + itemData.style.hover"
        @click="
          showMustGoOn(itemData.showIt || itemData.content, itemData.zoom, itemData.comicShow);
          goTo(itemData.goTo);
        "
        :style="{
          width: '100%',
          height: '100%',
          padding: itemData.style.padding,
          background: itemData.style.txtBcg,
          fontSize: itemData.style.fontSize + 'rem',
          margin: itemData.style.margin || 0,
          textAlign: itemData.style.textAlign || 'center',
          fontFamily: itemData.style.font || 'Arial',
          lineHeight: itemData.style.lineHeight,
          animationDelay: (itemData.style.delay | 0) / 100 + 's',
        }"
        v-if="itemData.type == 'text'"
        v-html="itemData.content"
      ></p>
      <h1
        :class="itemData.style.class + ' ' + itemData.style.hover"
        :style="{
          width: '100%',
          height: '100%',
          margin: itemData.style.margin || 0,
          fontFamily: itemData.style.font || appConf.font,
          animationDelay: (itemData.style.delay | 0) / 100 + 's',
        }"
        v-if="itemData.type == 'title'"
      >
        {{ itemData.content }}
      </h1>
      <atom
        :class="itemData.style.class"
        :item-style="itemData.style.style"
        v-if="itemData.type == 'atom'"
        :style="{ animationDelay: (itemData.style.delay | 0) / 100 + 's' }"
      ></atom>
      <colorMix
        :class="itemData.style.class"
        :item-style="itemData.style.style"
        :item-src="itemData.content"
        :item-zoom="itemData.zoom"
        :item-go-to="itemData.goTo"
        :item-show-it="itemData.showIt"
        v-if="itemData.type == 'colorMix'"
        :style="{ animationDelay: (itemData.style.delay | 0) / 100 + 's' }"
      ></colorMix>
      <bubble
        @click="showMustGoOn(itemData.showIt || itemData.content, itemData.zoom)"
        :class="itemData.style.class"
        :item-style="itemData.style.style"
        v-if="itemData.type == 'bubble'"
        :style="{
          animationDuration: (200 + (itemData.style.delay | 0) / 100) / 100 + 's',
        }"
      ></bubble>
      <smoke
        :class="itemData.style.class"
        :item-style="itemData.style.style"
        v-if="itemData.type == 'smoke'"
        :style="{ animationDelay: (itemData.style.delay | 0) / 100 + 's' }"
      ></smoke>
      <atoms :item-style="itemData.style.style" v-if="itemData.type == 'atoms'"></atoms>
      <signature
        :class="itemData.style.class"
        :item-style="itemData.style.style"
        v-if="itemData.type == 'signature'"
        :style="{ animationDelay: (itemData.style.delay | 0) / 100 + 's' }"
      ></signature>
      <bird
        :class="itemData.style.class"
        :item-style="itemData.style.style"
        v-if="itemData.type == 'bird'"
        :style="{ animationDelay: (itemData.style.delay | 0) / 100 + 's' }"
      ></bird>
    </div>
  </div>
</template>
<script>
import atom from '../awesomeSvg/atom';
import atoms from '../awesomeSvg/atoms';
import colorMix from '../awesomeSvg/colorMix';
import bubble from '../awesomeSvg/bubble';
import smoke from '../awesomeSvg/smoke';
import signature from '../awesomeSvg/signature';
import bird from '../awesomeSvg/bird';
import { Howl } from 'howler';
export default {
  name: 'box-in-the-box',
  components: { atom, bubble, signature, atoms, smoke, bird, colorMix },
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    conf: {
      default: () => {
        return { font: 'Lato' };
      },
      type: Object,
    },
  },
  data() {
    return {
      animationNo: false,
      hoverOnImg: false,
      appConf: this.conf,
      canShowIt: false,
      audio: null,
      timeoutAnimation: null,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    if (this.audio) {
      this.audio.stop();
      this.$parent.$parent.$parent.$emit('mainAudioStateCheck', false);
    }
  },
  methods: {
    giveMePathPlease(path) {
      // console.log(path);
      if (path) return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setAutoTriggerOff(it) {
      this.animationNo = false;
      if (this.timeoutAnimation) clearTimeout(this.timeoutAnimation);
      if (it.autoTriggerEnd) {
        this.timeoutAnimation = setTimeout(() => {
          if (this.audioVisible) {
            this.animationNo = true;
          }
        }, it.autoTriggerEnd * 1000);
      }
    },
    init() {
      if (this.itemData.audio) {
        this.audio = new Howl({
          src: [this.giveMePathPlease(this.itemData.audio.src)],
          autoplay: false,
          loop: false,
          volume: 0.2,
          onend: () => {
            // this.audio.fade(0.01, 0.1, 1000);
            this.$parent.$parent.$parent.$emit('mainAudioStateCheck', false);
          },
          onstop: () => {
            // this.audio.fade(0.01, 0.1, 1000);
            this.$parent.$parent.$parent.$emit('mainAudioStateCheck', false);
          },
          onplay: () => {
            // this.audio.fade(0.1, 0.01, 1000);
          },
        });
      }
    },
    stopSound() {
      if (this.audio) {
        this.audio.stop();
      }
    },
    playSound() {
      if (this.audio && !this.audio.playing()) {
        this.$parent.$parent.$parent.$emit('mainAudioStateCheck', true);
        setTimeout(() => {
          this.audio.play();
        }, 500);
      } else if (this.audio) {
        this.audio.stop();
      }
    },
    changeCanShowIt() {
      let time = (this.itemData.style.delay | 0) * 10 + 2100;
      setTimeout(() => {
        this.canShowIt = true;
      }, time);
    },
    goTo(go) {
      if (this.canShowIt) {
        if (go) {
          this.$parent.$parent.$parent.$emit('goToStepNow', go);
          this.$store.commit('STATE_SET_GO_TO', go);
        }
      }
    },
    chceckMineBinding(bind) {
      console.log(bind + ' : ' + this.mainBind);
      if (this.mainBind != 'all' && this.mainBind != '') {
        if (bind) {
          if (bind == this.mainBind) return true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkBinding(bind) {
      if (this.binding != '') {
        if (this.binding == bind || this.binding == 'all') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    showMustGoOn(img, zoom, comicShow, bind) {
      if (zoom) {
        this.$store.commit('STATE_SET_IMG_TO_SHOW', img);
        this.$store.commit('STATE_SET_GALERY_OPEN', true);
      }
      if (comicShow) {
        this.$store.commit('STATE_COMIC_SHOW', !this.showComic);
        if (bind) {
          this.$store.commit('STATE_PRESENTATION_BINDING', bind);
        } else {
          this.$store.commit('STATE_PRESENTATION_BINDING', '');
        }
      }
    },
  },
  watch: {
    stateGaleryOpen(newValue) {
      if (newValue == false) {
        this.stopSound();
      }
    },
  },
  computed: {
    stateGaleryOpen() {
      return this.$store.getters.getGaleryOpen;
    },
    mainBind() {
      return this.$store.getters.getCurrentMainBind;
    },
    showComic() {
      return this.$store.getters.getComicShow;
    },
    binding() {
      return this.$store.getters.getCurrentBind;
    },
    audioVisible() {
      this.setAutoTriggerOff(this.itemData);
      return this.$store.getters.getAudio;
    },
    audioWait() {
      return this.$store.getters.getAudioWait;
    },
    autoPlay() {
      return this.$store.getters.getAutoMove;
    },
  },
};
</script>
<style lang="sass" scoped>
@import '../../style/base'
@import '../../style/animation'

#box-in-the-box
  //background-position: center !important
  background-repeat: no-repeat !important
  background-size: cover !important
  position: absolute
  display: block
  transition: .5s
  transition-delay: 0s
  img
    width: 100%
    height: 100%
    object-fit: contain
.info-fade-enter-active
  transition-delay: .5s
.lamp
  border-radius: 50%
  position: fixed
  opacity: 0
  animation-delay: 1s
  animation-name: lampOn
  animation-iteration-count: infinite
.active-class
  transition-duration: .5s
  transform: scale(1.1, 1.1)
.innerBox
  transition-duration: .5s

#box-in-the-box::-webkit-scrollbar-track
  -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.2)
  background-color: white

#box-in-the-box::-webkit-scrollbar
  width: 10px
  background-color: white

#box-in-the-box::-webkit-scrollbar-thumb
  background-color: #034898
  border: 2px solid #034898
</style>
